import { redemptionsApiUrl } from 'Constants/Constants';
import axios from 'axios';

const redemptionsApiClient = axios.create({
  baseURL: redemptionsApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default redemptionsApiClient;
